// extracted by mini-css-extract-plugin
module.exports = {"richTextViewer":"richtextviewer_richTextViewer__xaSK4"};